//import Uiconstants from "../../lib/UIconstants"
import CloseController from "../../controllers/CloseController";
import FastspindialogueController from "../../controllers/fastspin_dialogue/FastspindialogueController";
import MainGridController from "../../controllers/grid/MainGridController";
import { COMPONENTS } from "../../lib/constants";
import { FastplayDialogueViewGrid } from "./FastplayDialogueViewGrid";

export const FastplayDialogueView = {
  name: COMPONENTS.FAST_PLAY_DIALOGUE,
  child: true,
  zIndex: 2,
  position: {
    x: 0,
    y: 0,
  },
  controllers: [
    {
      Controller: CloseController,
      name: "CloseController",
      config: {
        closeBtn: "close",
        remove: true,
        holder: "fast_play_holder",
      },
    },
    {
      Controller: FastspindialogueController,
      name: "FastspindialogueController",
      config: {
        item: "fsSprite",
        value: "fsSprite",
        holder: "fast_play_holder",
      },
    },
    {
      Controller: MainGridController,
      name: "FastSpinDialogueGrid",
      config: FastplayDialogueViewGrid,
    },
  ],
  components: [
    {
      name: "fast_play_holder",
      type: "Sprite",
      components: [
        {
          name: "bg",
          type: "Sprite",
          img: "dialog_main_bg",
          position: { x: 0, y: 0 },
        },
        {
          name: "bg_border",
          type: "Sprite",
          img: "sm_modal_frame",
          position: { x: -20, y: -20 },
        },
        {
          name: "header",
          type: "Text",
          text: "FASTPLAY_DIALOGUE_TITLE",
          position: { x: 587 / 2, y: 30 },
          anchor: {
            x: 0.5,
            y: 0,
          },
        },
        {
          name: "FASTPLAY_DIALOGUE_TEXT_1",
          type: "Text",
          text: "FASTPLAY_DIALOGUE_TEXT_1",
          position: { x: 40, y: 110 },
        },
        {
          name: "FASTPLAY_DIALOGUE_TEXT_2",
          type: "Text",
          text: "FASTPLAY_DIALOGUE_TEXT_2",
          position: { x: 125, y: 150 },
        },
        {
          name: "FASTPLAY_DIALOGUE_FAST_PLAY",
          type: "Text",
          text: "FASTPLAY_DIALOGUE_FAST_PLAY",
          position: { x: 390, y: 153 },
        },
        {
          name: "FASTPLAY_DIALOGUE_NOTE",
          type: "Text",
          text: "FASTPLAY_DIALOGUE_NOTE",
          position: { x: 90, y: 210 },
        },
        {
          name: "FASTPLAY_DIALOGUE_FAST_PLAY_SM",
          type: "Text",
          text: "FASTPLAY_DIALOGUE_FAST_PLAY_SM",
          position: { x: 420, y: 213 },
        },
        {
          name: "FASTPLAY_DIALOGUE_NOTE_END",
          type: "Text",
          text: "FASTPLAY_DIALOGUE_NOTE_END",
          position: { x: 587 / 2, y: 248 },
          anchor: { x: 0.5, y: 0.5 },
        },
        {
          name: "fsSprite",
          type: "Sprite",
          position: { x: 190, y: 285 },
          components: [
            {
              name: "fs",
              type: "SwitchButton",
              position: { x: 0, y: 11 },
              bg: "checkbox_active",
              fg: "checkbox_inactive",
            },
            {
              name: "fsText",
              type: "Sprite",
              components: [
                {
                  name: "fstext",
                  type: "Text",
                  position: { x: 30, y: 4 },
                  text: "FASTPLAY_DIALOGUE_TOGGLE",
                },
                {
                  name: "fstext",
                  type: "Text",
                  position: { x: 133, y: 7 },
                  text: "FASTPLAY_DIALOGUE_FAST_PLAY",
                },
              ],
            },
          ],
        },
        {
          name: "close",
          type: "ActionButton",
          bg: "dialog_yes_btn",
          position: { x: 587 / 2, y: 395 },
        },
      ],
    },
  ],
};
